module.exports = __webpack_public_path__ + "img/Pocket Vapes.29756cd9.jpg";